module.exports = __webpack_public_path__ + "static/media/B2B.9d748c56.png";